export default __webpack_public_path__ + "static/media/info_error.d658fea3.svg";